export default "__VITE_ASSET__CAjPmoFP__"